import request from "@/plugins/axios";
import { CacheService } from "../service/common";
export default {
  // 获取一个账期内的对账单列表
  getStatementList(page, pageSize, billDate) {
    const url = `/Pay/Bill/BillStatisticalDetailsPageList?page=${page}&pageSize=${pageSize}&billDate=${billDate}`;
    return request.get(url);
  },
  // 获取一个账期内单个企业的对账单列表
  getCompStatementList(params) {
    const url = `/Pay/Bill/BillStatisticalDetailsCompPageList`;
    return request.get(url, { params });
  },
  // 获取一个账期差异记录
  getDifferenceList(page, pageSize, statisId, billDate) {
    const url = `/Pay/Bill/BillStatisticalErrorPageList?page=${page}&pageSize=${pageSize}&statisId=${statisId}&billDate=${billDate}`;
    return request.get(url);
  },

  // 结算总列表
  getSettleList(page, pageSize, period) {
    const url = `/Opencloud/Settlement/SettlementCompDetailsPageList?page=${page}&pageSize=${pageSize}&period=${period}`;
    return request.get(url);
  },
  // 结算企业明细表
  getSettleCompDetailList(params) {
    // pageIndex, pageSize, orderNo
    const url = `/Opencloud/Settlement/SettlementDetailsPageList`;
    return request.get(url, { params });
  },
  // 获取分账销售统计数据
  getBillStatisticalTotal() {
    const url = `/Pay/Bill/BillStatisticalTotal`;
    return request.get(url);
  },
  // 获取分账销售交易统计柱状图表
  getBillStatisticalRecent(area) {
    const url = `/Pay/Bill/BillStatisticalRecent?statisticalAreaEnum=${area}`;
    return request.get(url);
  },
  // 获取分账结账统计数据
  getSettlementAmount() {
    const { compId } = CacheService.get("comp");
    const url = `/Pay/Settlement/SettlementMerchantAmount?compId=${compId}`;
    return request.get(url);
  },
  // 获取分账销售交易统计柱状图表
  getSettlementHistogram(timeSlot) {
    const { compId } = CacheService.get("comp");
    const url = `/Pay/Settlement/SettlementMerchantHistogram?timeSlot=${timeSlot}&compId=${compId}`;
    return request.get(url);
  },
};
